<template>
    <span
        :class="
            'inline-block w-[63px] rounded-full px-3 py-1 text-center text-[15px] font-semibold ' +
            ' ' +
            scoreClass
        "
        >{{ scoreValue }}</span
    >
</template>

<script>
export default {
    name: "ScoreLabel",
    props: {
        score: {
            type: Number,
            default: 0,
        },
        emptyScore: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        scoreValue() {
            let scoreValue = null;

            if (this.emptyScore) {
                scoreValue = "--%";
            } else {
                scoreValue = Math.round(this.score * 100) + "%";
            }

            return scoreValue;
        },
        scoreClass() {
            let scoreClass = "bg-gray-200 text-gray-800";

            let floatScore = parseFloat(this.score);

            if (!this.emptyScore) {
                if (floatScore < 0.7) {
                    scoreClass = "bg-red-100 text-red-600";
                } else if (floatScore < 0.85) {
                    scoreClass = "bg-yellow-100 text-yellow-500";
                } else {
                    scoreClass = "bg-green-150 text-green-600";
                }
            }

            return scoreClass;
        },
    },
};
</script>

<style scoped></style>
